// extracted by mini-css-extract-plugin
export var button = "TogglableContent-module--button--3c605";
export var content = "TogglableContent-module--content--14d9e";
export var fadePop = "TogglableContent-module--fade-pop--ff8c3";
export var growHeightIn = "TogglableContent-module--grow-height-in--0291f";
export var icon = "TogglableContent-module--icon--95ebe";
export var open = "TogglableContent-module--open--71ea4";